/* ============ MIDNIGHT CREW · DEVOLUÇÕES (mc-devolucoes.js) ============ */
(function(){
'use strict';
/* ====== CONFIG (mesma implantação Web App do dashboard) ====== */
var MC_API='https://script.google.com/macros/s/AKfycbx4cDDEvk8YNl8_ObUtTyXL44ASWsO24yYbN4RUmPpSekq3eGhyuZGRQ4ieg8_DBoUq/exec';
var MC_TOKEN='mc_cc6f126b6aaf46bfa553068c22727813';

/* ====== state ====== */
var devs=[], itens=[], motivos=[], ordersAll=[], prodSales={}, prodImgs={};
var itensByDev={};
var range='max';
var recentOrders=null;
var filters={q:'',tipo:'',motivo:'',estado:'',status:''};
var crossDim='motivo_tamanho', rankSort='qtd', tlGran='semana';
var _prejBreak={prod:0,logi:0,total:0};
/* modal cadastro */
var edit={id:null, order:null, items:[], selected:{}};

/* ====== util ====== */
function $(s){return document.querySelector(s);}
function el(id){return document.getElementById(id);}
function BRL(v){return 'R$ '+Number(v||0).toLocaleString('pt-BR',{minimumFractionDigits:2,maximumFractionDigits:2});}
function BRLk(v){v=Number(v||0);return v>=1000?('R$ '+(v/1000).toFixed(1).replace('.',',')+'k'):BRL(v);}
function PCT(v){return (Number(v||0)*100).toFixed(1).replace('.',',')+'%';}
function esc(s){return String(s==null?'':s).replace(/[&<>"]/g,function(c){return({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'})[c];});}
function fmtDate(s){if(!s)return'-';var d=new Date(s);return isNaN(d)?'-':d.toLocaleDateString('pt-BR');}
function todayISO(){return new Date().toISOString().slice(0,10);}
function daysBetween(a,b){var d1=new Date(a),d2=new Date(b);if(isNaN(d1)||isNaN(d2))return null;return Math.round((d2-d1)/86400000);}
function num(v){var n=parseFloat(v);return isNaN(n)?0:n;}
/* status novos (rastreio) + mapeamento dos legados */
var ST_LEGACY={'':'Devolução gerada','Aberta':'Devolução gerada','Em aberto':'Devolução gerada','Em trânsito':'Devolução enviada','Recebida':'Aguardando reembolso','Reembolsada':'Aguardando reembolso','Concluída':'Concluído'};
/* status disponíveis por tipo (menu da tag) */
var ST_DEV=['Devolução gerada','Devolução enviada','Aguardando reembolso','Concluído'];
var ST_TROCA=['Devolução gerada','Devolução enviada','Aguardando reenvio','Em produção','Reenviado','Concluído'];
function stNorm(s){s=String(s||'');return ST_LEGACY[s]!=null?ST_LEGACY[s]:s;}
function statusClass(s){return 's-'+String(s||'').replace(/[^a-z]/gi,'').toLowerCase();}
function uid(){return 'DEV'+Date.now().toString(36)+Math.random().toString(36).slice(2,6);}
function debounce(fn,ms){var t;return function(){var a=arguments,c=this;clearTimeout(t);t=setTimeout(function(){fn.apply(c,a);},ms);};}
/* ícones (mesmo estilo dos insights do detalhe de produto) */
var ICO={
  info:'<circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="11"/><line x1="12" y1="7.5" x2="12.01" y2="7.5"/>',
  alert:'<path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>',
  check:'<polyline points="20 6 9 17 4 12"/>',
  ruler:'<path d="M16 2 22 8 8 22 2 16 16 2z"/><path d="M9 9l1.5 1.5M12 6l1.5 1.5M6 12l1.5 1.5"/>',
  pin:'<path d="M12 21s-7-6.5-7-11a7 7 0 0 1 14 0c0 4.5-7 11-7 11z"/><circle cx="12" cy="10" r="2.5"/>',
  swap:'<polyline points="17 1 21 5 17 9"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/><polyline points="7 23 3 19 7 15"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/>',
  clock:'<circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>',
  bulb:'<path d="M9 18h6"/><path d="M10 22h4"/><path d="M15.09 14c.18-.98.65-1.74 1.41-2.5A4.65 4.65 0 0 0 18 8 6 6 0 0 0 6 8c0 1 .23 2.23 1.5 3.5A4.61 4.61 0 0 1 8.91 14"/>',
  tag:'<path d="M20.6 13.4 12 22l-9-9V3h10l7.6 7.6a2 2 0 0 1 0 2.8z"/><circle cx="7.5" cy="7.5" r="1.5"/>',
  chart:'<line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/>',
  truck:'<rect x="1" y="6" width="13" height="10" rx="1"/><path d="M14 9h4l3 3v4h-7z"/><circle cx="5.5" cy="18.5" r="1.6"/><circle cx="17.5" cy="18.5" r="1.6"/>',
  coins:'<circle cx="9" cy="9" r="6"/><path d="M15 3.5a6 6 0 0 1 0 11.9"/><path d="M6 9h6M9 6v6"/>',
  history:'<path d="M3 3v5h5"/><path d="M3.05 13A9 9 0 1 0 6 5.3L3 8"/><path d="M12 7v5l4 2"/>',
  percent:'<line x1="19" y1="5" x2="5" y2="19"/><circle cx="6.5" cy="6.5" r="2.5"/><circle cx="17.5" cy="17.5" r="2.5"/>',
  box:'<path d="M21 16V8a2 2 0 0 0-1-1.7l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.7l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.3 7 12 12 20.7 7"/><line x1="12" y1="22" x2="12" y2="12"/>',
  file:'<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/>',
  cart:'<circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>'
};
function icSvg(name){return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">'+(ICO[name]||ICO.info)+'</svg>';}

/* ── saving badge / toast ── */
var pendingSaves=0;
function beginSave(){pendingSaves++;var e=el('mcg-saving');if(e)e.classList.add('show');}
function endSave(){pendingSaves=Math.max(0,pendingSaves-1);if(pendingSaves===0){var e=el('mcg-saving');if(e)e.classList.remove('show');}}
function toast(msg){var t=el('mcg-toast');if(!t){t=document.createElement('div');t.id='mcg-toast';($('#mc-root')||document.body).appendChild(t);}t.textContent=msg;t.classList.add('show');clearTimeout(toast._t);toast._t=setTimeout(function(){t.classList.remove('show');},2400);}

/* ── JSONP (convenção Midnight-Sync) ── */
function mcCall(resource,params,cb){
  var cbName='_mcd_'+Date.now()+'_'+Math.random().toString(36).slice(2);
  var url=MC_API+'?key='+encodeURIComponent(MC_TOKEN)+'&callback='+cbName+'&resource='+encodeURIComponent(resource);
  if(params)Object.keys(params).forEach(function(k){url+='&'+k+'='+encodeURIComponent(params[k]);});
  var s=document.createElement('script');
  window[cbName]=function(d){try{delete window[cbName];}catch(e){}if(s.parentNode)s.parentNode.removeChild(s);cb(null,d);};
  s.src=url;s.onerror=function(){try{delete window[cbName];}catch(e){}cb(new Error('net'));};
  document.head.appendChild(s);
  setTimeout(function(){if(window[cbName]){try{delete window[cbName];}catch(e){}cb(new Error('timeout'));}},25000);
}

/* ── dropdown customizado (idêntico ao gastos) ── */
function buildAllCS(){document.querySelectorAll('#mc-root select').forEach(buildCS);}
function buildCS(sel){
  if(sel.dataset.csDone||sel.classList.contains('mcd-hidden-native'))return;sel.dataset.csDone='1';
  var wrap=document.createElement('div');wrap.className='mcg-cs';
  if(sel.classList.contains('mcd-mini-select'))wrap.classList.add('mcd-cs-mini');
  sel.parentNode.insertBefore(wrap,sel);wrap.appendChild(sel);sel.classList.add('mcg-cs-native');
  var trig=document.createElement('button');trig.type='button';trig.className='mcg-cs-trigger';
  var list=document.createElement('div');list.className='mcg-cs-list';
  wrap.appendChild(trig);wrap.appendChild(list);
  trig.addEventListener('click',function(e){e.stopPropagation();var open=wrap.classList.contains('open');closeAllCS();if(!open)wrap.classList.add('open');});
  refreshCS(sel);
}
function refreshCS(sel){
  if(!sel||!sel.dataset.csDone)return;var wrap=sel.parentNode;if(!wrap||!wrap.classList.contains('mcg-cs'))return;
  var trig=wrap.querySelector('.mcg-cs-trigger'),list=wrap.querySelector('.mcg-cs-list');
  var cur=sel.options[sel.selectedIndex];trig.textContent=cur?cur.textContent:'';list.innerHTML='';
  Array.prototype.forEach.call(sel.options,function(o){
    var it=document.createElement('div');it.className='mcg-cs-item'+(o.selected?' sel':'')+(o.className?(' '+o.className):'');it.textContent=o.textContent;
    it.addEventListener('click',function(e){e.stopPropagation();wrap.classList.remove('open');sel.value=o.value;refreshCS(sel);sel.dispatchEvent(new Event('change',{bubbles:true}));});
    list.appendChild(it);
  });
}
function closeAllCS(){document.querySelectorAll('#mc-root .mcg-cs.open').forEach(function(w){w.classList.remove('open');});}
document.addEventListener('click',closeAllCS);

/* ============ carregar dados ============ */
function periodFrom(r){
  var now=new Date();
  if(r==='7d')return new Date(now-7*864e5);
  if(r==='30d')return new Date(now-30*864e5);
  if(r==='3m')return new Date(now-90*864e5);
  if(r==='mes')return new Date(now.getFullYear(),now.getMonth(),1);
  if(r==='ano')return new Date(now.getFullYear(),0,1);
  return new Date(0);
}
/* ── cache (stale-while-revalidate em localStorage) ── */
function cacheGet(k){try{var s=localStorage.getItem(k);return s?JSON.parse(s):null;}catch(e){return null;}}
function cacheSet(k,v){try{localStorage.setItem(k,JSON.stringify(v));}catch(e){}}
function rebuildItensIndex(){itensByDev={};itens.forEach(function(it){(itensByDev[it.devolucao_id]=itensByDev[it.devolucao_id]||[]).push(it);});}

function loadMotivos(cb){
  var c=cacheGet('mcd_motivos_v1');
  if(c&&c.rows){motivos=c.rows.filter(function(m){return String(m.ativo)!=='0';});fillMotivoSelects();if(cb){cb();cb=null;}}
  mcCall('dev_motivos_list',{},function(err,d){
    if(err||!d||!d.data)return;
    motivos=(d.data||[]).filter(function(m){return String(m.ativo)!=='0';});
    cacheSet('mcd_motivos_v1',{ts:Date.now(),rows:d.data||[]});
    fillMotivoSelects();if(cb)cb();
  });
}
function loadOrders(){
  var c=cacheGet('mcd_orders_v1');
  if(c&&c.rows){ordersAll=c.rows;renderAll();}
  mcCall('orders',{range:'max'},function(err,d){
    if(err||!d||!d.rows)return;
    ordersAll=d.rows;cacheSet('mcd_orders_v1',{ts:Date.now(),rows:d.rows});renderAll();
  });
}
function loadProdSales(){
  var c=cacheGet('mcd_prodsales2_'+range);
  if(c&&c.map){prodSales=c.map;prodImgs=c.imgs||{};renderAll();}
  mcCall('products_period',{range:range},function(err,d){
    if(err||!d||!d.rows)return;
    prodSales={};prodImgs={};
    (d.rows||[]).forEach(function(p){ var pid=String(p.product_id); prodSales[pid]=num(p.unidades); if(p.image)prodImgs[pid]=String(p.image); });
    cacheSet('mcd_prodsales2_'+range,{ts:Date.now(),map:prodSales,imgs:prodImgs});renderAll();
  });
}
function loadDevs(){
  var c=cacheGet('mcd_devs_v1');
  if(c&&c.rows){devs=c.rows;itens=c.itens||[];rebuildItensIndex();renderAll();}
  else el('mcd-updated').textContent='Carregando...';
  mcCall('devolucoes_list',{},function(err,d){
    if(err||!d||!d.rows){if(!c)el('mcd-updated').textContent='Falha ao carregar.';return;}
    devs=d.rows;itens=d.itens||[];rebuildItensIndex();
    cacheSet('mcd_devs_v1',{ts:Date.now(),rows:devs,itens:itens});renderAll();
  });
}
/* pré-carrega os últimos pedidos p/ o modal abrir instantâneo */
function prefetchRecent(){
  var c=cacheGet('mcd_recent_v1');
  if(c&&c.rows)recentOrders=c.rows;
  mcCall('devolucao_recent',{limit:15},function(err,d){
    if(err||!d||!d.rows)return;recentOrders=d.rows;cacheSet('mcd_recent_v1',{ts:Date.now(),rows:d.rows});
  });
}

/* ============ filtragem ============ */
function inPeriod(dev){
  if(range==='max')return true;
  var from=periodFrom(range);
  var d=new Date(dev.data_devolucao||dev.created_at);
  return isNaN(d)?true:d>=from;
}
function applyFilters(){
  return devs.filter(function(dv){
    if(!inPeriod(dv))return false;
    if(filters.tipo&&String(dv.tipo)!==filters.tipo)return false;
    if(filters.motivo&&String(dv.motivo)!==filters.motivo)return false;
    if(filters.estado&&String(dv.estado)!==filters.estado)return false;
    if(filters.status&&stNorm(dv.status)!==filters.status)return false;
    if(filters.q){
      var q=filters.q.toLowerCase();
      var hay=(dv.order_number+' '+dv.customer_name+' '+dv.motivo+' '+dv.motivo_detalhe).toLowerCase();
      if(hay.indexOf(q)<0)return false;
    }
    return true;
  });
}
function itensOf(fdevs){
  var ids={};fdevs.forEach(function(d){ids[d.id]=1;});
  return itens.filter(function(it){return ids[it.devolucao_id];});
}

/* ============ render principal ============ */
function renderAll(){
  var f=applyFilters();
  renderKpis(f);
  renderFunnel(f);
  renderMotivos(f);
  renderRank(f);
  renderCross(f);
  renderGeo(f);
  renderTimeline(f);
  renderInsights(f);
  renderList(f);
  fillFilterOptions();
  el('mcd-updated').textContent=f.length+' devoluções • atualizado '+new Date().toLocaleTimeString('pt-BR',{hour:'2-digit',minute:'2-digit'});
}

/* KPIs */
function logisticaOf(dv){return num(dv.custo_logistico)+num(dv.custo_reenvio);}
function custoProdOf(dv){return num(dv.custo_produto);}
function valorDevOf(dv){return String(dv.tipo)!=='troca'?num(dv.valor_itens):0;}
/* trocas: custo do NOVO produto reenviado (kits já registram o custo cheio do kit, então ficam de fora) */
function isKitItem(it){var parts=String(it.variant_title||'').split('/').map(function(s){return s.trim();}).filter(Boolean);return parts.length>=2;}
function custoNovoOf(dv){
  if(String(dv.tipo)!=='troca')return 0;
  var s=0;(itensByDev[dv.id]||[]).forEach(function(it){
    if(isKitItem(it))return;
    s+=num(it.custo_linha)||num(it.custo_unitario)*num(it.quantity);
  });
  return s;
}
function prejuizoOf(dv){return logisticaOf(dv)+custoProdOf(dv)+valorDevOf(dv)+custoNovoOf(dv);}
function ordersInPeriod(){
  if(range==='max')return ordersAll;
  var from=periodFrom(range);
  return ordersAll.filter(function(o){var d=new Date(o.created_at);return isNaN(d)?false:d>=from;});
}
function renderKpis(f){
  var nOrders=ordersInPeriod().length;
  var pedidos=f.length;
  var produtos=0,valor=0,prejuizo=0,logiSum=0,prodSum=0,novoSum=0,custolog=0,tempoSum=0,tempoN=0,trocas=0,reemb=0,fatur=0;
  f.forEach(function(dv){
    produtos+=num(dv.qtd_itens);
    if(String(dv.tipo)!=='troca')valor+=num(dv.valor_itens);   // valor devolvido: só devoluções
    prejuizo+=prejuizoOf(dv); logiSum+=logisticaOf(dv); prodSum+=custoProdOf(dv); novoSum+=custoNovoOf(dv); custolog+=num(dv.custo_logistico)+num(dv.custo_reenvio);
    if(String(dv.tipo)==='troca')trocas++;else reemb++;
    var t=daysBetween(dv.data_pedido,dv.data_devolucao);if(t!=null&&t>=0){tempoSum+=t;tempoN++;}
  });
  ordersInPeriod().forEach(function(o){fatur+=num(o.faturamento);});
  _prejBreak={prod:prodSum,logi:logiSum,val:valor,total:prejuizo};
  var taxa=nOrders?pedidos/nOrders:0;
  var logiRet=0,logiTroca=0,tMin=null,tMax=null;
  f.forEach(function(dv){
    logiRet+=num(dv.custo_logistico);logiTroca+=num(dv.custo_reenvio);
    var t=daysBetween(dv.data_pedido,dv.data_devolucao);
    if(t!=null&&t>=0){if(tMin==null||t<tMin)tMin=t;if(tMax==null||t>tMax)tMax=t;}
  });
  function set(id,v){var e=el(id);if(e)e.textContent=v;}
  /* linha 1 */
  set('mcd-k-taxa',PCT(taxa));
  set('mcd-pp-taxa-devs',pedidos+' / '+nOrders);set('mcd-pp-taxa-prods',produtos);
  set('mcd-k-pedidos',pedidos);
  set('mcd-pp-ped-trocas',trocas);set('mcd-pp-ped-reemb',reemb);set('mcd-pp-ped-prods',produtos);
  set('mcd-k-troca',trocas+' / '+reemb);
  set('mcd-pp-troca-pct',pedidos?PCT(trocas/pedidos):'-');set('mcd-pp-reemb-pct',pedidos?PCT(reemb/pedidos):'-');
  set('mcd-k-prejuizo',BRL(prejuizo));
  set('mcd-pop-prod',BRL(prodSum));set('mcd-pop-novo',BRL(novoSum));set('mcd-pop-valor',BRL(valor));set('mcd-pop-logi',BRL(logiSum));set('mcd-pop-total',BRL(prejuizo));
  set('mcd-k-ticket',reemb?BRL(valor/reemb):'-');
  set('mcd-pp-tk-valor',BRL(valor));set('mcd-pp-tk-reemb',reemb);
  /* linha 2 */
  set('mcd-k-pctfat',fatur?PCT(valor/fatur):'-');
  set('mcd-pp-fat-valor',BRL(valor));set('mcd-pp-fat-total',BRL(fatur));
  set('mcd-k-customed',pedidos?BRL(prejuizo/pedidos):'-');
  set('mcd-pp-cm-prej',BRL(prejuizo));set('mcd-pp-cm-n',pedidos);
  set('mcd-k-custolog',pedidos?BRL(custolog/pedidos):'-');
  set('mcd-pp-log-ret',BRL(logiRet));set('mcd-pp-log-troca',BRL(logiTroca));
  set('mcd-k-tempo',tempoN?(Math.round(tempoSum/tempoN)+' dias'):'-');
  set('mcd-pp-tp-min',tMin!=null?(tMin+' dias'):'-');set('mcd-pp-tp-max',tMax!=null?(tMax+' dias'):'-');
  /* economia potencial = prejuízo do principal motivo */
  var byMot={};f.forEach(function(dv){var m=dv.motivo||'—';byMot[m]=(byMot[m]||0)+prejuizoOf(dv);});
  var topMot='',topVal=0;Object.keys(byMot).forEach(function(m){if(byMot[m]>topVal){topVal=byMot[m];topMot=m;}});
  set('mcd-k-economia',BRL(topVal));
  set('mcd-k-economia-sub',topMot?('se resolver: '+topMot):'');
  set('mcd-pp-eco-mot',topMot||'—');set('mcd-pp-eco-val',BRL(topVal));
  /* barras de proporção dos popovers */
  function setBar(id,pct){var e=el(id);if(e)e.style.width=Math.max(0,Math.min(100,pct)).toFixed(1)+'%';}
  setBar('mcd-pb-trocas',pedidos?trocas/pedidos*100:0);setBar('mcd-pb-reembs',pedidos?reemb/pedidos*100:0);
  var pTot=prejuizo||1;
  setBar('mcd-pb-prod',prodSum/pTot*100);setBar('mcd-pb-novo',novoSum/pTot*100);setBar('mcd-pb-valor',valor/pTot*100);setBar('mcd-pb-logi',logiSum/pTot*100);
  setBar('mcd-pb-fat',fatur?valor/fatur*100:0);
  var lTot=(logiRet+logiTroca)||1;
  setBar('mcd-pb-log-ret',logiRet/lTot*100);setBar('mcd-pb-log-troca',logiTroca/lTot*100);
}

/* Funil vertical por estágio (mesmo visual do funil de conversão do detalhe de produto) */
function renderFunnel(f){
  if(!f.length){el('mcd-funnel').innerHTML='<p class="mc-empty">Sem devoluções no período.</p>';return;}
  var stages=[{n:'Geradas',ic:'file'},{n:'Em trânsito',ic:'truck'},{n:'Recebidas',ic:'box'},{n:'Reenviadas',ic:'coins'},{n:'Concluídas',ic:'check'}];
  var order={'Devolução gerada':0,'Devolução enviada':1,'Aguardando reembolso':2,'Aguardando reenvio':2,'Em produção':2,'Reenviado':3,'Concluído':4};
  var counts=[0,0,0,0,0];
  f.forEach(function(dv){var lvl=order[stNorm(dv.status)];if(lvl==null)lvl=0;for(var i=0;i<=lvl;i++)counts[i]++;});
  var top=counts[0]||1;
  el('mcd-funnel').innerHTML=stages.map(function(s,i){
    var pct=counts[i]/top;var h=Math.max(3,pct*100);
    return '<div class="mcd-vf" title="'+s.n+': '+counts[i]+'">'+
      '<span class="mcd-vf-num">'+counts[i]+'</span>'+
      '<div class="mcd-vf-col"><div class="mcd-vf-fill" style="height:'+h.toFixed(1)+'%"></div></div>'+
      '<span class="mcd-vf-pct">'+(pct*100).toFixed(pct<0.1?1:0)+'%</span>'+
      '<span class="mcd-vf-lab"><span class="mcd-vf-ic">'+icSvg(s.ic)+'</span>'+s.n+'</span></div>';
  }).join('');
}

/* Motivos */
function renderMotivos(f){
  var g={};f.forEach(function(dv){var m=dv.motivo||'—';g[m]=g[m]||{q:0,v:0};g[m].q++;g[m].v+=prejuizoOf(dv);});
  var arr=Object.keys(g).map(function(m){return{m:m,q:g[m].q,v:g[m].v};}).sort(function(a,b){return b.q-a.q;});
  var max=arr.length?arr[0].q:1,total=f.length||1;
  el('mcd-motivos-hint').textContent=arr.length?(arr.length+' motivos'):'';
  if(!arr.length){el('mcd-motivos').innerHTML='<p class="mc-empty">Sem dados no período.</p>';return;}
  el('mcd-motivos').innerHTML=arr.map(function(r){
    return '<div class="mcd-mot-row"><span class="mcd-mot-nm" title="'+esc(r.m)+'">'+esc(r.m)+'</span>'+
      '<span class="mcd-bar-wrap"><span class="mcd-bar" style="width:'+(r.q/max*100)+'%"></span></span>'+
      '<span class="mcd-mot-qtd">'+r.q+'</span>'+
      '<span class="mcd-mot-pct">'+PCT(r.q/total)+'</span>'+
      '<span class="mcd-mot-val">'+BRLk(r.v)+'</span></div>';
  }).join('');
}

/* Ranking de produtos */
function renderRank(f){
  var its=itensOf(f);
  var g={};
  its.forEach(function(it){
    var pid=String(it.product_id||it.title);var k=pid;
    var e=g[k]||(g[k]={pid:pid,title:it.title,q:0,v:0,mot:{}});
    e.q+=num(it.quantity);e.v+=num(it.line_revenue);
  });
  /* motivo principal por produto (via dev parent) */
  var devById={};f.forEach(function(dv){devById[dv.id]=dv;});
  its.forEach(function(it){var k=String(it.product_id||it.title);var dv=devById[it.devolucao_id];if(dv&&g[k]){var m=dv.motivo||'—';g[k].mot[m]=(g[k].mot[m]||0)+1;}});
  var arr=Object.keys(g).map(function(k){
    var e=g[k];var vendas=prodSales[e.pid]||0;var taxa=vendas?e.q/vendas:0;
    var topMot='',mv=0;Object.keys(e.mot).forEach(function(m){if(e.mot[m]>mv){mv=e.mot[m];topMot=m;}});
    return{title:e.title,pid:e.pid,q:e.q,v:e.v,vendas:vendas,taxa:taxa,mot:topMot};
  });
  arr.sort(function(a,b){return rankSort==='taxa'?b.taxa-a.taxa:rankSort==='prejuizo'?b.v-a.v:b.q-a.q;});
  arr=arr.slice(0,12);
  if(!arr.length){el('mcd-rank').innerHTML='<p class="mc-empty">Sem dados no período.</p>';return;}
  var metric=function(r){return rankSort==='taxa'?r.taxa:rankSort==='prejuizo'?r.v:r.q;};
  var mMax=Math.max.apply(null,arr.map(metric))||1;
  el('mcd-rank').innerHTML=arr.map(function(r){
    var tag=rankSort==='taxa'?(r.vendas?PCT(r.taxa):'—'):rankSort==='prejuizo'?BRLk(r.v):(r.q+'x');
    var hot=(rankSort==='taxa'&&r.taxa>=0.08)||(rankSort==='qtd'&&r.q>=max3(arr));
    var img=prodImgs[r.pid]?'<img class="mcd-rank-img" src="'+esc(prodImgs[r.pid])+'" loading="lazy" alt="">':'<span class="mcd-rank-img mcd-rank-noimg"></span>';
    var w=(metric(r)/mMax*100).toFixed(1);
    return '<div class="mcd-rank-row">'+img+
      '<span class="mcd-rank-nm" title="'+esc(r.title)+'">'+esc(r.title)+'<small>'+(r.mot?esc(r.mot):'sem motivo')+
      (r.vendas?(' • '+r.vendas+' vendas'):'')+'</small></span>'+
      '<span class="mcd-bar-wrap mcd-rank-barw"><span class="mcd-bar'+(hot?' hot':'')+'" style="width:'+w+'%"></span></span>'+
      '<span class="mcd-rank-qtd">'+r.q+'</span>'+
      '<span class="mcd-rank-val">'+BRLk(r.v)+'</span>'+
      '<span class="mcd-rank-tag'+(hot?' hot':'')+'">'+tag+'</span></div>';
  }).join('');
}
function max3(arr){var s=arr.map(function(a){return a.q;}).sort(function(a,b){return b-a;});return s[2]||s[s.length-1]||0;}

/* Cruzamentos (heatmap) */
function dimVal(dim,it,dv){
  if(dim==='motivo')return dv.motivo||'—';
  if(dim==='tamanho')return it.tamanho||'—';
  if(dim==='cor')return it.cor||'—';
  if(dim==='produto')return it.title||'—';
  if(dim==='canal')return dv.canal||dv.origem||'—';
  if(dim==='estado')return dv.estado||'—';
  if(dim==='tipo')return dv.tipo==='troca'?'Troca':'Devolução';
  return '—';
}
function renderCross(f){
  var parts=crossDim.split('_');var dr=parts[0],dc=parts[1];
  var devById={};f.forEach(function(dv){devById[dv.id]=dv;});
  var its=itensOf(f);
  var rows={},cols={},cell={};
  its.forEach(function(it){
    var dv=devById[it.devolucao_id];if(!dv)return;
    var rv=dimVal(dr,it,dv),cv=dimVal(dc,it,dv);var q=num(it.quantity)||1;
    rows[rv]=(rows[rv]||0)+q;cols[cv]=(cols[cv]||0)+q;
    cell[rv+'|||'+cv]=(cell[rv+'|||'+cv]||0)+q;
  });
  var rKeys=Object.keys(rows).sort(function(a,b){return rows[b]-rows[a];}).slice(0,6);
  if(!rKeys.length){el('mcd-cross').innerHTML='<p class="mc-empty">Sem dados no período.</p>';return;}
  var labelMap={motivo:'Motivo',tamanho:'Tamanho',cor:'Cor',produto:'Produto',canal:'Canal',estado:'Estado',tipo:'Tipo'};
  var grandTot=0;rKeys.forEach(function(r){grandTot+=rows[r];});
  /* um cartão por item principal; dentro, a quebra da 2ª dimensão nomeada linha a linha */
  var h='<div class="mcd-cx2-grid">';
  rKeys.forEach(function(r){
    var tot=rows[r];
    var subs=Object.keys(cols).map(function(c){return{c:c,v:cell[r+'|||'+c]||0};})
      .filter(function(s){return s.v>0;})
      .sort(function(a,b){return b.v-a.v;});
    var top=subs.slice(0,5);
    var otherV=0;subs.slice(5).forEach(function(s){otherV+=s.v;});
    var body=top.map(function(s){
      var pct=Math.round(s.v/tot*100);
      return '<div class="mcd-cx2-sub"><span class="cx2-nm" title="'+esc(s.c)+'">'+esc(s.c)+'</span>'+
        '<span class="cx2-bar"><i data-w="'+(s.v/tot*100).toFixed(1)+'"></i></span>'+
        '<span class="cx2-ct"><b>'+s.v+'</b>'+pct+'%</span></div>';
    }).join('');
    if(otherV){var op2=Math.round(otherV/tot*100);
      body+='<div class="mcd-cx2-sub cx2-other"><span class="cx2-nm">Outros</span>'+
        '<span class="cx2-bar"><i data-w="'+(otherV/tot*100).toFixed(1)+'"></i></span>'+
        '<span class="cx2-ct"><b>'+otherV+'</b>'+op2+'%</span></div>';}
    h+='<div class="mcd-cx2-card">'+
      '<div class="mcd-cx2-head"><span class="cx2-title" title="'+esc(r)+'">'+esc(r)+'</span>'+
      '<span class="cx2-tot"><b>'+tot+'</b> '+(tot>1?'itens':'item')+' · '+Math.round(tot/grandTot*100)+'%</span></div>'+
      '<div class="mcd-cx2-cap">por '+labelMap[dc].toLowerCase()+'</div>'+
      body+'</div>';
  });
  h+='</div>';
  el('mcd-cross').innerHTML=h;
  requestAnimationFrame(function(){
    el('mcd-cross').querySelectorAll('.cx2-bar i').forEach(function(sg){sg.style.width=sg.getAttribute('data-w')+'%';});
  });
}

/* Geografia — mapa do Brasil (bolhas posicionadas por lat/long real) */
var UF_GEO={
  AC:[-70.5,-9.0],AL:[-36.6,-9.6],AP:[-51.8,1.4],AM:[-64.7,-4.1],BA:[-41.7,-12.5],CE:[-39.6,-5.1],
  DF:[-47.9,-15.8],ES:[-40.6,-19.6],GO:[-49.6,-16.0],MA:[-45.4,-5.4],MT:[-55.9,-12.9],MS:[-54.9,-20.5],
  MG:[-44.5,-18.5],PA:[-52.8,-4.3],PB:[-36.6,-7.2],PR:[-51.6,-24.6],PE:[-37.9,-8.4],PI:[-42.7,-7.3],
  RJ:[-42.6,-22.3],RN:[-36.6,-5.8],RS:[-53.5,-30.2],RO:[-63.0,-10.9],RR:[-61.4,2.1],SC:[-50.4,-27.3],
  SP:[-48.7,-22.2],SE:[-37.4,-10.6],TO:[-48.3,-10.2]
};
var UF_REGION={AC:'N',AM:'N',AP:'N',PA:'N',RO:'N',RR:'N',TO:'N',MA:'NE',PI:'NE',CE:'NE',RN:'NE',PB:'NE',PE:'NE',AL:'NE',SE:'NE',BA:'NE',MT:'CO',MS:'CO',GO:'CO',DF:'CO',MG:'SE',ES:'SE',RJ:'SE',SP:'SE',PR:'S',SC:'S',RS:'S'};
var REGION_COLOR={N:'#3fb6c9',NE:'#f5a623',CO:'#48f91e',SE:'#ff5d8f',S:'#7eb3ff'};
var REGION_NAME={N:'Norte',NE:'Nordeste',CO:'Centro-Oeste',SE:'Sudeste',S:'Sul'};
var UF_NAMES={'acre':'AC','alagoas':'AL','amapa':'AP','amapá':'AP','amazonas':'AM','bahia':'BA','ceara':'CE','ceará':'CE','distrito federal':'DF','espirito santo':'ES','espírito santo':'ES','goias':'GO','goiás':'GO','maranhao':'MA','maranhão':'MA','mato grosso':'MT','mato grosso do sul':'MS','minas gerais':'MG','para':'PA','pará':'PA','paraiba':'PB','paraíba':'PB','parana':'PR','paraná':'PR','pernambuco':'PE','piaui':'PI','piauí':'PI','rio de janeiro':'RJ','rio grande do norte':'RN','rio grande do sul':'RS','rondonia':'RO','rondônia':'RO','roraima':'RR','santa catarina':'SC','sao paulo':'SP','são paulo':'SP','sergipe':'SE','tocantins':'TO'};
function toUF(v){
  var s=String(v||'').trim();if(!s)return '';
  var up=s.toUpperCase();
  if(up.length===2)return up; // já é sigla
  var low=s.toLowerCase();
  return UF_NAMES[low]||up;
}
/* ===== MAPA: Leaflet + GeoJSON vetorial (minimalista, sem tiles) =====
   Fundo sólido (= cor dos países, textura só no oceano). Só traços: fronteiras + rios.
   Cidades do Brasil só via nossos marcadores (aparecem no zoom). ===== */
var MAP_BG='#0a0a0a', GEO_HOME=[[-14.6,-53.0],3.6];
function ensureLeaflet(cb){
  if(window.L){cb();return;}
  if(!document.getElementById('mcd-leaflet-css')){
    var lk=document.createElement('link');lk.id='mcd-leaflet-css';lk.rel='stylesheet';
    lk.href='https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';document.head.appendChild(lk);
  }
  var ex=document.getElementById('mcd-leaflet-js');
  if(ex){ex.addEventListener('load',function(){cb();});if(window.L)cb();return;}
  var s=document.createElement('script');s.id='mcd-leaflet-js';
  s.src='https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';s.onload=function(){cb();};document.head.appendChild(s);
}
function geoTopOf(o){var k='',v=0;Object.keys(o).forEach(function(x){if(o[x]>v){v=o[x];k=x;}});return k;}
function geoDrill(uf,d){
  var dr=el('mcd-geo-drill');if(!dr)return;
  var cities=Object.keys(d.cid).sort(function(a,b){return d.cid[b]-d.cid[a];});
  var mx=cities.length?d.cid[cities[0]]:1;
  dr.innerHTML='<h3><span>'+uf+' — cidades ('+d.q+' devoluções)</span><span class="gd-close" id="mcd-drill-close">✕ fechar</span></h3>'+
    (cities.length?cities.map(function(c){return '<div class="mcd-city-row"><span class="mcd-city-nm" title="'+esc(c)+'">'+esc(c)+'</span><span class="mcd-city-bar"><i style="width:'+(d.cid[c]/mx*100)+'%"></i></span><span class="mcd-city-n">'+d.cid[c]+'</span></div>';}).join(''):'<p class="mc-empty">Sem cidade registrada.</p>');
  dr.classList.add('show');
  el('mcd-drill-close').addEventListener('click',function(){dr.classList.remove('show');});
}
var _map=null,_mLayer=null,_geoData=null,_vecDone=false;
function renderGeo(f){
  var host=el('mcd-geo');
  var g={};
  f.forEach(function(dv){var uf=toUF(dv.estado);if(!uf||!UF_GEO[uf])return;g[uf]=g[uf]||{q:0,v:0,cid:{},mot:{}};g[uf].q++;g[uf].v+=prejuizoOf(dv);
    if(dv.cidade)g[uf].cid[dv.cidade]=(g[uf].cid[dv.cidade]||0)+1;if(dv.motivo)g[uf].mot[dv.motivo]=(g[uf].mot[dv.motivo]||0)+1;});
  if(!Object.keys(g).length){_geoData=null;if(_mLayer)_mLayer.clearLayers();if(!el('mcd-mlmap'))host.innerHTML='<p class="mc-empty">Sem dados de estado no período.</p>';return;}
  _geoData=g;
  if(!el('mcd-mlmap')){
    host.innerHTML='<div class="mcd-mapbox"><div class="mcd-mlmap" id="mcd-mlmap"></div>'+
      '<button class="mcd-map-reset" id="mcd-map-reset" title="Resetar zoom"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 3v5h5"/><path d="M3.05 13A9 9 0 1 0 6 5.3L3 8"/></svg> Resetar</button></div>'+
      '<div class="mcd-geo-drill" id="mcd-geo-drill"></div>';
    _map=null;_mLayer=null;_vecDone=false;
  }
  ensureLeaflet(function(){ drawMap(); });
}
function drawMap(){
  var host=el('mcd-mlmap');if(!host||!window.L)return;
  if(!_map){
    _map=L.map(host,{zoomControl:false,attributionControl:false,scrollWheelZoom:true,minZoom:3,maxZoom:18,zoomSnap:0.5}).setView(GEO_HOME[0],GEO_HOME[1]);
    /* mapa natural (tiles CARTO dark, COM cidades e rios) — nada por cima */
    L.tileLayer('https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png',{subdomains:'abcd',maxZoom:20}).addTo(_map);
    _mLayer=L.layerGroup().addTo(_map);
    _map.on('zoomend',renderMarkers);
    var rb=el('mcd-map-reset');if(rb)rb.addEventListener('click',function(){_map.setView(GEO_HOME[0],GEO_HOME[1]);});
  }
  setTimeout(function(){try{_map.invalidateSize();}catch(e){}},90);
  renderMarkers();
}
function renderMarkers(){
  if(!_map||!_mLayer||!_geoData||!window.L)return;
  _mLayer.clearLayers();
  var g=_geoData,z=_map.getZoom();
  var ufs=Object.keys(g),maxQ=Math.max.apply(null,ufs.map(function(u){return g[u].q;}))||1;
  var cityMode=z>=6, cityCount=z>=8?99:(z>=7?6:3);
  ufs.forEach(function(uf){
    var d=g[uf],ll=UF_GEO[uf];
    if(!cityMode){
      var r=Math.round(12+Math.sqrt(d.q/maxQ)*14);
      var html='<div class="mcd-lmk" style="width:'+(2*r)+'px;height:'+(2*r)+'px"><span>'+d.q+'</span><small>'+uf+'</small></div>';
      var mk=L.marker([ll[1],ll[0]],{icon:L.divIcon({html:html,className:'mcd-lmk-wrap',iconSize:[2*r,2*r],iconAnchor:[r,r]})}).addTo(_mLayer);
      mk.bindTooltip('<b>'+uf+' · '+REGION_NAME[UF_REGION[uf]]+'</b><br>Devoluções: <b>'+d.q+'</b><br>Prejuízo: '+BRLk(d.v)+'<br>Motivo: '+esc(geoTopOf(d.mot)||'—')+'<br>Cidade: '+esc(geoTopOf(d.cid)||'—'),{direction:'top',offset:[0,-r],className:'mcd-ltip',opacity:1});
      mk.on('click',function(){geoDrill(uf,d);});
    }else{
      var cities=Object.keys(d.cid).sort(function(a,b){return d.cid[b]-d.cid[a];}).slice(0,cityCount);
      cities.forEach(function(ci,i){
        var pos=cityRealPos(ci,uf)||cityLatLng(uf,i);var cq=d.cid[ci];var cr=z>=8?15:13;
        var chtml='<div class="mcd-cwrap"><span class="mcd-cnum" style="width:'+(2*cr)+'px;height:'+(2*cr)+'px">'+cq+'</span></div>';
        var cm=L.marker(pos,{icon:L.divIcon({html:chtml,className:'mcd-lmk-wrap',iconSize:[2*cr,2*cr],iconAnchor:[cr,cr]})}).addTo(_mLayer);
        cm.bindTooltip('<b>'+esc(ci)+'</b> · '+uf+'<br>Devoluções: <b>'+cq+'</b>',{direction:'top',offset:[0,-cr],className:'mcd-ltip',opacity:1});
        cm.on('click',function(){geoDrill(uf,d);});
      });
    }
  });
}
function cityLatLng(uf,i){
  var c=UF_GEO[uf];var ang=i*2.399963;var dist=0.55+0.5*Math.sqrt(i);
  return [c[1]+Math.sin(ang)*dist, c[0]+Math.cos(ang)*dist];
}
/* geocodificação real das cidades (Nominatim/OSM, 1 req/s, cache) */
var _geoCodeCache=null,_geoQueue=[],_geoBusy=false;
function geoCodeMap(){if(!_geoCodeCache)_geoCodeCache=cacheGet('mcd_geocode_v1')||{};return _geoCodeCache;}
function cityRealPos(city,uf){
  var key=(String(city)+'|'+uf).toLowerCase();var c=geoCodeMap();
  if(c[key]!=null)return c[key]==='x'?null:c[key];
  if(_geoQueue.indexOf(key)<0){_geoQueue.push(key);runGeoQueue();}
  return null;
}
function runGeoQueue(){
  if(_geoBusy||!_geoQueue.length)return;_geoBusy=true;
  var key=_geoQueue.shift();var parts=key.split('|');
  var url='https://nominatim.openstreetmap.org/search?format=json&limit=1&countrycodes=br&q='+encodeURIComponent(parts[0]+', '+parts[1].toUpperCase()+', Brasil');
  fetch(url,{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(d){
    var c=geoCodeMap();c[key]=(d&&d[0])?[parseFloat(d[0].lat),parseFloat(d[0].lon)]:'x';cacheSet('mcd_geocode_v1',c);
  }).catch(function(){}).then(function(){
    setTimeout(function(){_geoBusy=false;if(_geoQueue.length)runGeoQueue();else renderMarkers();},1100);
  });
}

/* Linha do tempo */
function tlKey(d,g){
  var dt=new Date(d);if(isNaN(dt))return null;
  if(g==='mes')return dt.getFullYear()+'-'+String(dt.getMonth()+1).padStart(2,'0');
  if(g==='semana'){var on=new Date(dt);on.setDate(dt.getDate()-((dt.getDay()+6)%7));return on.toISOString().slice(0,10);}
  return dt.toISOString().slice(0,10);
}
function tlLabel(k){
  if(tlGran==='mes'){var p=k.split('-');return p[1]+'/'+p[0].slice(2);}
  var d=new Date(k);if(isNaN(d))return k;return String(d.getDate()).padStart(2,'0')+'/'+String(d.getMonth()+1).padStart(2,'0');
}
function renderTimeline(f){
  var g={};f.forEach(function(dv){var k=tlKey(dv.data_devolucao||dv.created_at,tlGran);if(k)g[k]=(g[k]||0)+1;});
  var keys=Object.keys(g).sort();
  var host=el('mcd-timeline');
  if(!keys.length){host.innerHTML='<p class="mc-empty">Sem dados no período.</p>';return;}
  var vals=keys.map(function(k){return g[k];});
  var n=vals.length;
  var W=Math.max(320,host.clientWidth||600),H=190,padL=32,padR=14,padT=16,padB=26;
  var plotW=W-padL-padR,plotH=H-padT-padB;
  var vMax=Math.max.apply(null,vals);if(vMax<1)vMax=1;
  function xP(i){return n<=1?padL+plotW/2:padL+plotW*i/(n-1);}
  function yP(v){return padT+plotH*(1-v/vMax);}
  var pts=vals.map(function(v,i){return xP(i).toFixed(1)+','+yP(v).toFixed(1);}).join(' ');
  var area=padL+','+(padT+plotH)+' '+pts+' '+(W-padR)+','+(padT+plotH);
  var grid='',steps=4;
  for(var s=0;s<=steps;s++){var yy=padT+plotH*s/steps;var vv=Math.round(vMax*(1-s/steps));
    grid+='<line x1="'+padL+'" y1="'+yy.toFixed(1)+'" x2="'+(W-padR)+'" y2="'+yy.toFixed(1)+'" stroke="rgba(255,255,255,'+(s===steps?'.22':'.05')+')" stroke-width="1"/>'+
      '<text x="'+(padL-6)+'" y="'+(yy+3).toFixed(1)+'" text-anchor="end" fill="#8a8a8a" font-size="9" font-family="var(--mono)">'+vv+'</text>';}
  var every=Math.max(1,Math.ceil(n/7)),xlab='';
  keys.forEach(function(k,i){if(i%every===0||i===n-1){xlab+='<text x="'+xP(i).toFixed(1)+'" y="'+(H-8)+'" text-anchor="middle" fill="#8a8a8a" font-size="9" font-family="var(--mono)">'+esc(tlLabel(k))+'</text>';}});
  var dots=vals.map(function(v,i){return '<circle cx="'+xP(i).toFixed(1)+'" cy="'+yP(v).toFixed(1)+'" r="2.6" fill="var(--acc)"/>';}).join('');
  var svg='<svg viewBox="0 0 '+W+' '+H+'" width="100%" height="'+H+'" style="display:block;overflow:visible">'+
    '<defs><linearGradient id="mcdtlg" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="rgba(255,242,0,.20)"/><stop offset="1" stop-color="rgba(255,242,0,0)"/></linearGradient></defs>'+
    grid+
    '<polygon points="'+area+'" fill="url(#mcdtlg)"/>'+
    '<polyline points="'+pts+'" fill="none" stroke="var(--acc)" stroke-width="2" stroke-linejoin="round" stroke-linecap="round" class="mcd-tlline"/>'+
    dots+
    '<line class="mcd-tlguide" x1="0" y1="'+padT+'" x2="0" y2="'+(padT+plotH)+'" stroke="var(--acc)" stroke-width="1" stroke-dasharray="3,3" style="display:none"/>'+
    '<circle class="mcd-tlmk" r="4" fill="var(--acc)" stroke="#0a0a0a" stroke-width="2" style="display:none"/>'+
    xlab+'</svg>';
  host.innerHTML='<div class="mcd-tlwrap">'+svg+'<div class="mcd-tltip" style="display:none"></div></div>';
  var svgEl=host.querySelector('svg'),guide=host.querySelector('.mcd-tlguide'),mk=host.querySelector('.mcd-tlmk'),tip=host.querySelector('.mcd-tltip');
  function toX(clientX){var r=svgEl.getBoundingClientRect();return (clientX-r.left)*(W/r.width);}
  svgEl.addEventListener('mousemove',function(ev){
    var mx=toX(ev.clientX);var i=Math.round((mx-padL)/(plotW||1)*(n-1));i=Math.max(0,Math.min(n-1,i));
    var x=xP(i),y=yP(vals[i]);
    guide.setAttribute('x1',x);guide.setAttribute('x2',x);guide.style.display='';
    mk.setAttribute('cx',x);mk.setAttribute('cy',y);mk.style.display='';
    tip.style.display='block';tip.innerHTML='<b>'+vals[i]+'</b> devoluções<span>'+esc(keys[i])+'</span>';
    var r=svgEl.getBoundingClientRect();var px=x*(r.width/W);
    tip.style.left=Math.max(0,Math.min(px-tip.offsetWidth/2,r.width-tip.offsetWidth))+'px';
  });
  svgEl.addEventListener('mouseleave',function(){guide.style.display='none';mk.style.display='none';tip.style.display='none';});
}

/* Diagnóstico / insights */
function renderInsights(f){
  var out=[];
  if(f.length<2){
    el('mcd-insights').innerHTML='<div class="pad-aid-empty">Sem dados suficientes para gerar insights.</div>';
    var fb0=el('pad-ai-fab');if(fb0)fb0.innerHTML='<span class="pad-fab-dot"></span>Diagnóstico';
    return;
  }
  var total=f.length;
  /* top motivo */
  var byMot={};f.forEach(function(dv){var m=dv.motivo||'—';byMot[m]=(byMot[m]||0)+1;});
  var motArr=Object.keys(byMot).sort(function(a,b){return byMot[b]-byMot[a];});
  if(motArr[0]&&motArr[0]!=='—'){
    var share=byMot[motArr[0]]/total;
    out.push({cls:'',ico:'info',html:'O motivo <b>'+esc(motArr[0])+'</b> concentra <b>'+PCT(share)+'</b> das devoluções ('+byMot[motArr[0]]+' de '+total+').'});
  }
  /* produto com maior taxa */
  var its=itensOf(f),gp={};
  its.forEach(function(it){var k=String(it.product_id||it.title);gp[k]=gp[k]||{t:it.title,pid:String(it.product_id),q:0};gp[k].q+=num(it.quantity);});
  var best=null;Object.keys(gp).forEach(function(k){var vendas=prodSales[gp[k].pid]||0;if(vendas>=10){var tx=gp[k].q/vendas;if(!best||tx>best.tx)best={title:gp[k].t,tx:tx,q:gp[k].q,vendas:vendas};}});
  if(best&&best.tx>=0.05)out.push({cls:'alert',ico:'alert',html:'<b>'+esc(best.title)+'</b> tem taxa de devolução de <b>'+PCT(best.tx)+'</b> ('+best.q+' de '+best.vendas+' vendas) — acima do saudável.'});
  /* tamanho dominante em um motivo de modelagem */
  var sizeMot={};its.forEach(function(it){var dv=f.filter(function(d){return d.id===it.devolucao_id;})[0];if(!dv)return;var m=(dv.motivo||'').toLowerCase();if(m.indexOf('tamanho')>=0&&it.tamanho){sizeMot[it.tamanho]=(sizeMot[it.tamanho]||0)+num(it.quantity);}});
  var szKeys=Object.keys(sizeMot).sort(function(a,b){return sizeMot[b]-sizeMot[a];});
  if(szKeys.length){var tot=szKeys.reduce(function(s,k){return s+sizeMot[k];},0);out.push({cls:'',ico:'ruler',html:'Nas devoluções por tamanho, o <b>'+esc(szKeys[0])+'</b> lidera com <b>'+PCT(sizeMot[szKeys[0]]/tot)+'</b> — possível ajuste de modelagem.'});}
  /* estado destaque */
  var byUf={};f.forEach(function(dv){if(dv.estado)byUf[dv.estado]=(byUf[dv.estado]||0)+1;});
  var ufKeys=Object.keys(byUf).sort(function(a,b){return byUf[b]-byUf[a];});
  if(ufKeys.length>=2)out.push({cls:'',ico:'pin',html:'<b>'+esc(ufKeys[0])+'</b> é o estado com mais devoluções ('+byUf[ufKeys[0]]+'), seguido de '+esc(ufKeys[1])+' ('+byUf[ufKeys[1]]+').'});
  /* tipo split */
  var tr=f.filter(function(d){return d.tipo==='troca';}).length;
  out.push({cls:'',ico:'swap',html:'<b>'+PCT(tr/total)+'</b> das solicitações são trocas e <b>'+PCT((total-tr)/total)+'</b> reembolsos.'});
  /* tempo médio */
  var ts=0,tn=0;f.forEach(function(dv){var t=daysBetween(dv.data_pedido,dv.data_devolucao);if(t!=null&&t>=0){ts+=t;tn++;}});
  if(tn)out.push({cls:'',ico:'clock',html:'Tempo médio entre compra e devolução: <b>'+Math.round(ts/tn)+' dias</b>.'});
  /* economia */
  var byMotV={};f.forEach(function(dv){var m=dv.motivo||'—';byMotV[m]=(byMotV[m]||0)+prejuizoOf(dv);});
  var topV='',tv=0;Object.keys(byMotV).forEach(function(m){if(byMotV[m]>tv){tv=byMotV[m];topV=m;}});
  if(tv>0)out.push({cls:'good',ico:'bulb',html:'Eliminando o motivo <b>'+esc(topV)+'</b> a economia potencial é de <b>'+BRL(tv)+'</b> no período.'});

  // mesmo formato dos insights do detalhe de produto (pad-aid-item)
  var toneMap={'':'acc','good':'pos','alert':'warn'};
  el('mcd-insights').innerHTML=out.map(function(o){
    return '<div class="pad-aid-item"><span class="pad-aid-ico '+(toneMap[o.cls||'']||'acc')+'">'+icSvg(o.ico)+'</span>'+
      '<span class="pad-aid-txt">'+o.html+'</span></div>';
  }).join('');
  var fab=el('pad-ai-fab');
  if(fab)fab.innerHTML='<span class="pad-fab-dot"></span>Diagnóstico'+(out.length?(' · '+out.length):'');
}
/* botão flutuante + drawer do diagnóstico (mesmo comportamento do detalhe de produto) */
function wireDiagDrawer(){
  var fab=el('pad-ai-fab'),drawer=el('pad-ai-drawer');
  if(!fab||!drawer)return;
  setTimeout(function(){fab.classList.add('is-visible');},220);
  function open(){
    drawer.classList.add('open');
    Array.prototype.forEach.call(drawer.querySelectorAll('.pad-aid-item'),function(x,i){x.style.transitionDelay=(90+i*70)+'ms';});
  }
  function close(){
    drawer.classList.remove('open');
    Array.prototype.forEach.call(drawer.querySelectorAll('.pad-aid-item'),function(x){x.style.transitionDelay='0ms';});
  }
  fab.addEventListener('click',function(e){e.stopPropagation();drawer.classList.contains('open')?close():open();});
  drawer.querySelector('.pad-aid-close').addEventListener('click',close);
  document.addEventListener('click',function(e){
    if(drawer.classList.contains('open')&&!drawer.contains(e.target)&&!fab.contains(e.target))close();
  });
}

/* Lista de registros */
/* célula de rastreio: troca com código de reenvio rastreia o REENVIO; senão, a devolução */
function trackCell(dv){
  var isTroca=String(dv.tipo)==='troca';
  var code='',lbl='',ev='';
  if(isTroca&&String(dv.tracking_troca||'').trim()){code=dv.tracking_troca;lbl='reenvio';ev=dv.troca_evento||'';}
  else if(String(dv.tracking_retorno||'').trim()){code=dv.tracking_retorno;lbl='devolução';ev=dv.ret_evento||'';}
  if(!code)return '<td class="mcd-td-mut">—</td>';
  var c=String(code).replace(/\s/g,'');
  return '<td class="mcd-td-track"><a class="mc-track-link" href="https://rastreio.frenet.com.br/COR/'+esc(c)+'" target="_blank" rel="noopener" onclick="event.stopPropagation()">'+esc(c)+'</a>'+
    '<small>'+esc(lbl)+'</small></td>';
}
/* estágio do envio (mesmo formato da página de pedidos: evento + local) */
function stageCell(dv){
  var isTroca=String(dv.tipo)==='troca';
  var ev='',loc='';
  if(isTroca&&String(dv.tracking_troca||'').trim()){ev=dv.troca_evento||'';loc=dv.troca_local||'';}
  else if(String(dv.tracking_retorno||'').trim()){ev=dv.ret_evento||'';loc=dv.ret_local||'';}
  if(!ev)return '<td class="mcd-td-mut">-</td>';
  return '<td class="mcd-td-stage">'+esc(ev)+(loc?('<small>'+esc(loc)+'</small>'):'')+'</td>';
}
var listPage=1,listPerPage=10;
function renderPages(totalPages){
  var box=el('mcd-pages');if(!box)return;
  if(totalPages<1)totalPages=1;
  var h='<button data-p="prev"'+(listPage<=1?' disabled':'')+'>&lt; Ant</button>';
  var start=Math.max(1,listPage-3),end=Math.min(totalPages,start+6);start=Math.max(1,end-6);
  for(var p=start;p<=end;p++)h+='<button data-p="'+p+'"'+(p===listPage?' class="is-active"':'')+'>'+p+'</button>';
  h+='<button data-p="next"'+(listPage>=totalPages?' disabled':'')+'>Próx &gt;</button>';
  box.innerHTML=h;
  box.querySelectorAll('button[data-p]').forEach(function(b){
    b.addEventListener('click',function(){
      var v=b.getAttribute('data-p');
      if(v==='prev')listPage=Math.max(1,listPage-1);
      else if(v==='next')listPage=listPage+1;
      else listPage=+v;
      renderList(applyFilters());
    });
  });
}
function renderList(f){
  var arr=f.slice().sort(function(a,b){return new Date(b.data_devolucao||b.created_at)-new Date(a.data_devolucao||a.created_at);});
  el('mcd-list-count').textContent=arr.length+' registros';
  if(!arr.length){el('mcd-list').innerHTML='<p class="mc-empty">Nenhuma devolução — clique em "Nova devolução".</p>';renderPages(0);return;}
  var totalPages=Math.ceil(arr.length/listPerPage);
  if(listPage>totalPages)listPage=totalPages;
  if(listPage<1)listPage=1;
  renderPages(totalPages);
  arr=arr.slice((listPage-1)*listPerPage,listPage*listPerPage);
  var body=arr.map(function(dv){
    var tcls=dv.tipo==='troca'?'troca':'devolucao';var tlbl=dv.tipo==='troca'?'Troca':'Devolução';
    var st=stNorm(dv.status);
    return '<tr data-id="'+esc(dv.id)+'">'+
      '<td class="mcd-td-id">#MNC'+esc(dv.order_number)+'</td>'+
      '<td><span class="mc-pill mcd-st-trigger '+statusClass(st)+'" data-dvid="'+esc(dv.id)+'">'+esc(st)+'</span></td>'+
      '<td>'+esc(dv.customer_name||'—')+'</td>'+
      '<td><span class="mcd-tag '+tcls+'">'+tlbl+'</span></td>'+
      trackCell(dv)+
      stageCell(dv)+
      '<td>'+esc(dv.estado||'—')+'</td>'+
      '<td class="mcd-td-mut" title="'+esc(dv.motivo)+'">'+esc(dv.motivo||'—')+'</td>'+
      '<td class="mcd-td-num">'+num(dv.qtd_itens)+'</td>'+
      '<td class="mcd-td-val mcd-prej-cell" data-pid="'+esc(dv.id)+'">'+BRLk(prejuizoOf(dv))+'</td>'+
      '<td class="mcd-td-mut">'+fmtDate(dv.data_devolucao)+'</td></tr>';
  }).join('');
  el('mcd-list').innerHTML='<table class="mcd-table"><thead><tr>'+
    '<th>Pedido</th><th>Status</th><th>Cliente</th><th>Tipo</th><th>Rastreio</th><th>Estágio de Envio</th><th>Estado</th><th>Motivo</th><th class="mcd-td-num">Itens</th><th class="mcd-td-val">Prejuízo</th><th>Data</th>'+
    '</tr></thead><tbody>'+body+'</tbody></table>';
  el('mcd-list').querySelectorAll('tbody tr').forEach(function(row){
    row.addEventListener('click',function(ev){
      if(ev.target.closest('.mcd-st-trigger'))return; // clique na tag abre o menu de status
      if(ev.target.closest('a'))return;
      openEdit(row.getAttribute('data-id'));
    });
  });
  el('mcd-list').querySelectorAll('.mcd-st-trigger').forEach(function(pill){
    pill.addEventListener('click',function(ev){ev.stopPropagation();openStatusMenu(pill);});
  });
  bindPrejPops();
}
/* ── menu da tag de status: marcar Concluído manualmente ── */
function closeStatusMenu(){var m=el('mcd-st-dd');if(m)m.remove();}
document.addEventListener('click',closeStatusMenu);
function openStatusMenu(pill){
  closeStatusMenu();
  var id=pill.getAttribute('data-dvid');
  var dv=devs.filter(function(d){return String(d.id)===String(id);})[0];if(!dv)return;
  var cur=stNorm(dv.status);
  var opts=String(dv.tipo)==='troca'?ST_TROCA:ST_DEV;
  var m=document.createElement('div');m.id='mcd-st-dd';m.className='mcd-st-dd';
  m.innerHTML='<div class="mcd-st-dd-head">Status · '+(String(dv.tipo)==='troca'?'Troca':'Devolução')+'</div>'+
    opts.map(function(s){
      return '<div class="mcd-st-dd-item'+(s===cur?' is-cur':'')+'" data-v="'+esc(s)+'"><span class="mc-pill '+statusClass(s)+'">'+esc(s)+'</span></div>';
    }).join('');
  m.addEventListener('click',function(ev){ev.stopPropagation();});
  ($('#mc-root')||document.body).appendChild(m);
  var r=pill.getBoundingClientRect();
  m.style.left=Math.max(8,Math.min(r.left,window.innerWidth-m.offsetWidth-8))+'px';
  m.style.top=(r.bottom+6)+'px';
  m.querySelectorAll('.mcd-st-dd-item').forEach(function(it){
    it.addEventListener('click',function(){
      var novo=it.getAttribute('data-v');
      if(novo===cur){closeStatusMenu();return;}
      dv.status=novo;
      cacheSet('mcd_devs_v1',{ts:Date.now(),rows:devs,itens:itens});
      closeStatusMenu();renderAll();toast('Status atualizado.');
      beginSave();
      mcCall('devolucao_set_status',{id:id,status:novo},function(err,d){
        endSave();
        if(err||(d&&d.error)){toast('Falha ao salvar status — recarregando.');loadDevs();}
      });
    });
  });
}
/* janela flutuante com a composição do prejuízo de cada registro (estilo dos KPIs) */
function prejPopEl(){
  var p=el('mcd-prej-pop');
  if(!p){p=document.createElement('div');p.id='mcd-prej-pop';p.className='mcd-pop mcd-pop-fixed';($('#mc-root')||document.body).appendChild(p);}
  return p;
}
function bindPrejPops(){
  var devById={};devs.forEach(function(d){devById[d.id]=d;});
  el('mcd-list').querySelectorAll('.mcd-prej-cell').forEach(function(cd){
    cd.addEventListener('mouseenter',function(){
      var dv=devById[cd.getAttribute('data-pid')];if(!dv)return;
      var p=prejPopEl();
      var isTroca=String(dv.tipo)==='troca';
      var rows='<div class="mcd-pop-title">Composição do prejuízo</div>'+
        '<div class="mcd-pop-row"><span>Custo do produto'+(isTroca?' (devolvido)':'')+'</span><b>'+BRL(custoProdOf(dv))+'</b></div>'+
        '<div class="mcd-pop-row"><span>Frete retorno</span><b>'+BRL(num(dv.custo_logistico))+'</b></div>';
      if(isTroca){
        rows+='<div class="mcd-pop-row"><span>Frete reenvio</span><b>'+BRL(num(dv.custo_reenvio))+'</b></div>';
        var cn=custoNovoOf(dv);
        rows+='<div class="mcd-pop-row"><span>Novo produto (reenvio)</span><b>'+(cn>0?BRL(cn):BRL(0)+' <small style="color:#8a8a8a">· incluso no kit</small>')+'</b></div>';
      }
      if(valorDevOf(dv)>0)rows+='<div class="mcd-pop-row"><span>Reembolso ao cliente</span><b>'+BRL(valorDevOf(dv))+'</b></div>';
      rows+='<div class="mcd-pop-sep"></div><div class="mcd-pop-row total"><span>Total</span><b>'+BRL(prejuizoOf(dv))+'</b></div>';
      p.innerHTML=rows;p.style.display='block';
      var r=cd.getBoundingClientRect();
      var px=Math.min(r.left,window.innerWidth-290),py=r.bottom+6;
      if(py+p.offsetHeight>window.innerHeight)py=r.top-p.offsetHeight-6;
      p.style.left=Math.max(8,px)+'px';p.style.top=py+'px';
    });
    cd.addEventListener('mouseleave',function(){var p=el('mcd-prej-pop');if(p)p.style.display='none';});
  });
}

/* opções dinâmicas de filtro */
function fillFilterOptions(){
  var motSel=el('mcd-f-motivo'),ufSel=el('mcd-f-estado');
  var mset={},uset={};
  devs.forEach(function(dv){if(dv.motivo)mset[dv.motivo]=1;if(dv.estado)uset[dv.estado]=1;});
  syncSelect(motSel,Object.keys(mset).sort(),'Todos os motivos',filters.motivo);
  syncSelect(ufSel,Object.keys(uset).sort(),'Todos os estados',filters.estado);
}
function syncSelect(sel,vals,placeholder,cur){
  if(!sel)return;
  var want=['|'+placeholder].concat(vals.map(function(v){return v+'|'+v;})).join(',');
  if(sel.dataset.sig===want)return;sel.dataset.sig=want;
  sel.innerHTML='<option value="">'+placeholder+'</option>'+vals.map(function(v){return '<option value="'+esc(v)+'"'+(v===cur?' selected':'')+'>'+esc(v)+'</option>';}).join('');
  refreshCS(sel);
}
function motivosSorted(){return motivos.slice().sort(function(a,b){return String(a.nome).localeCompare(String(b.nome),'pt',{sensitivity:'base'});});}
function fillMotivoSelects(){
  var sorted=motivosSorted();
  var opts='<option value="">Motivo</option>'+sorted.map(function(m){return '<option value="'+esc(m.nome)+'">'+esc(m.nome)+'</option>';}).join('')+
    '<option value="__newmot__" class="mcg-opt-new">+ Adicionar novo motivo</option>';
  var s=el('mcd-f-motivo-in');if(s){var cur=s.value;s.innerHTML=opts;s.value=cur;refreshCS(s);}
}

/* ============ MODAL CADASTRO ============ */
function openNew(){
  edit={id:null,order:null,items:[],selected:{}};
  el('mcd-modal-title').textContent='Nova devolução';
  el('mcd-step-search').style.display='';
  el('mcd-step-items').style.display='none';
  el('mcd-order-results').className='mcd-order-results';
  el('mcd-order-results').innerHTML='';
  el('mcd-order-search').value='';
  el('mcd-modal-del').style.display='none';
  el('mcd-modal-back').style.display='none';
  el('mcd-modal-save').disabled=true;
  resetForm();
  el('mcd-modal-overlay').style.display='flex';
  setTimeout(function(){el('mcd-order-search').focus();},50);
}
function resetForm(){
  el('mcd-f-motivo-det').value='';el('mcd-f-custolog').value='';el('mcd-f-reenvio').value='';el('mcd-f-obs').value='';
  el('mcd-f-track-ret').value='';el('mcd-f-track-troca').value='';
  el('mcd-f-data-ret').value=todayISO();el('mcd-f-data-troca').value='';
  el('mcd-f-tipo-in').value='devolucao';refreshCS(el('mcd-f-tipo-in'));
  el('mcd-f-status-in').value='';refreshCS(el('mcd-f-status-in'));
  var m=el('mcd-f-motivo-in');if(m){m.value='';refreshCS(m);}
  toggleTrocaField();
}
function closeModal(){el('mcd-modal-overlay').style.display='none';}
function toggleTrocaField(){
  var isTroca=el('mcd-f-tipo-in').value==='troca';
  el('mcd-leg-troca').style.display=isTroca?'':'none';
  var w=el('mcd-troca-tam-wrap');if(w)w.style.display='none'; // novo tamanho agora é por peça, dentro do item
  if(isTroca&&!el('mcd-f-data-troca').value)el('mcd-f-data-troca').value=todayISO();
  var seg=el('mcd-seg-tipo');
  if(seg)seg.querySelectorAll('button').forEach(function(b){b.classList.toggle('is-on',b.getAttribute('data-v')===el('mcd-f-tipo-in').value);});
  var si=el('mcd-step-items');
  if(si&&si.style.display!=='none'&&edit.items&&edit.items.length)renderItems();
}
function fillTrocaTamSelect(cur){
  var std=['PP','P','M','G','GG','XG','XGG','Único'];
  var extras=[];
  (edit.items||[]).forEach(function(it){if(it.tamanho&&std.indexOf(it.tamanho)<0&&extras.indexOf(it.tamanho)<0)extras.push(it.tamanho);});
  var opts=extras.concat(std);
  var s=el('mcd-f-troca-tam');if(!s)return;
  s.innerHTML='<option value="">Novo tamanho</option>'+opts.map(function(o){return '<option value="'+esc(o)+'">'+esc(o)+'</option>';}).join('');
  s.value=cur||'';refreshCS(s);
}
function renderOrderRows(rows,emptyMsg){
  var box=el('mcd-order-results');box.className='mcd-order-results show';
  if(!rows.length){box.innerHTML='<div class="mcd-or-row"><span class="mcd-or-cli">'+(emptyMsg||'Nenhum pedido encontrado.')+'</span></div>';return;}
  box.innerHTML=rows.map(function(o){
    return '<div class="mcd-or-row" data-oid="'+esc(o.id)+'">'+
      '<span class="mcd-or-id">#MNC'+esc(o.order_number)+'</span>'+
      '<span class="mcd-or-cli">'+esc(o.customer_name||'—')+'<small>'+esc(o.phone||'')+(o.estado?(' • '+esc(o.estado)):'')+'</small></span>'+
      '<span class="mcd-or-meta">'+fmtDate(o.created_at)+'<br>'+BRLk(o.faturamento)+'</span></div>';
  }).join('');
  box.querySelectorAll('.mcd-or-row[data-oid]').forEach(function(r){
    r.addEventListener('click',function(){selectOrder(rows.filter(function(x){return String(x.id)===r.getAttribute('data-oid');})[0]);});
  });
}
function loadRecentOrders(){
  if(recentOrders&&recentOrders.length){renderOrderRows(recentOrders,'Nenhum pedido recente.');return;} // instantâneo (cache)
  var box=el('mcd-order-results');box.className='mcd-order-results show';
  box.innerHTML='<div class="mcd-or-row"><span class="mcd-or-cli">Carregando últimos pedidos...</span></div>';
  mcCall('devolucao_recent',{limit:15},function(err,d){
    if(el('mcd-order-search').value.trim().length>=2)return; // usuário já digitou
    recentOrders=(d&&d.rows)||[];if(d&&d.rows)cacheSet('mcd_recent_v1',{ts:Date.now(),rows:d.rows});
    renderOrderRows(recentOrders,'Nenhum pedido recente.');
  });
}
function searchOrders(q){
  if(!q||q.length<2){loadRecentOrders();return;}
  el('mcd-order-results').className='mcd-order-results show';
  el('mcd-order-results').innerHTML='<div class="mcd-or-row"><span class="mcd-or-cli">Buscando...</span></div>';
  mcCall('devolucao_search',{q:q},function(err,d){
    renderOrderRows((d&&d.rows)||[]);
  });
}
function selectOrder(o){
  if(!o)return;
  edit.order=o;
  el('mcd-step-search').style.display='none';
  el('mcd-step-items').style.display='';
  el('mcd-modal-back').style.display='';
  el('mcd-order-head').innerHTML='<div><b>#MNC'+esc(o.order_number)+'</b> — '+esc(o.customer_name||'—')+'</div>'+
    '<span>'+esc(o.estado||'')+(o.cidade?(' · '+esc(o.cidade)):'')+' · '+fmtDate(o.created_at)+'</span>';
  el('mcd-items').innerHTML='<p class="mc-empty" style="padding:10px">Carregando itens...</p>';
  mcCall('devolucao_order_items',{order_id:o.id},function(err,d){
    edit.items=(d&&d.rows)||[];
    renderItems();
  });
}
var SIZE_STD=['PP','P','M','G','GG','XG','XGG','XXG','U','ÚNICO','UNICO'];
function isSizeTok(s){return SIZE_STD.indexOf(String(s||'').trim().toUpperCase())>=0;}
function itemInfo(it){
  var vt=String(it.variant_title||'');
  var parts=vt.split('/').map(function(s){return s.trim();}).filter(Boolean);
  var kit=parts.length>=2 && (/kit/i.test(it.title||'') || parts.every(isSizeTok));
  if(kit)return {kit:true,sizes:parts};
  return {kit:false,sizes:[it.tamanho||(parts.length===1?parts[0]:'')]};
}
function novoSelHtml(cur){
  var std=['PP','P','M','G','GG','XG','XGG','Único'];
  return '<select class="mcd-item-novo"><option value="">novo tam.</option>'+std.map(function(o){return '<option value="'+esc(o)+'"'+(o===cur?' selected':'')+'>'+esc(o)+'</option>';}).join('')+'</select>';
}
function ensureSel(ix){
  var info=itemInfo(edit.items[ix]);
  if(!edit.selected[ix])edit.selected[ix]={sizes:info.sizes,pieces:info.sizes.map(function(){return false;}),qtys:info.sizes.map(function(){return 1;}),novos:info.sizes.map(function(){return '';})};
  return edit.selected[ix];
}
function anySelected(){return Object.keys(edit.selected).some(function(ix){var s=edit.selected[ix];return s&&s.pieces&&s.pieces.some(Boolean);});}
function renderItems(){
  if(!edit.items.length){el('mcd-items').innerHTML='<p class="mc-empty" style="padding:10px">Sem itens neste pedido.</p>';return;}
  var isTroca=el('mcd-f-tipo-in').value==='troca';
  el('mcd-items').innerHTML=edit.items.map(function(it,ix){
    var info=itemInfo(it);var s=ensureSel(ix);
    var vt=it.variant_title&&it.variant_title!=='Default Title'?it.variant_title:'';
    if(info.kit){
      var pieces=info.sizes.map(function(sz,pi){
        var on=s.pieces[pi];
        return '<div class="mcd-kpiece'+(on?'':' off')+'" data-pi="'+pi+'">'+
          '<input type="checkbox" class="mcd-piece-chk" '+(on?'checked':'')+'>'+
          '<span class="mcd-piece-lbl">Peça '+(pi+1)+' · <b>'+esc(sz||'—')+'</b></span>'+
          (isTroca?('<span class="mcd-piece-novo"'+(on?'':' style="display:none"')+'>→ '+novoSelHtml(s.novos[pi])+'</span>'):'')+
          '</div>';
      }).join('');
      return '<div class="mcd-item mcd-item-kit" data-ix="'+ix+'" data-kit="1">'+
        '<div class="mcd-item-top"><span class="mcd-item-nm">'+esc(it.title)+'<small>KIT · '+esc(vt)+'</small></span>'+
        '<span class="mcd-item-val">'+BRLk(num(it.price))+'</span></div>'+
        '<div class="mcd-kpieces">'+pieces+'</div></div>';
    }
    var on0=s.pieces[0];var maxq=num(it.quantity)||1;var q=s.qtys[0]||maxq;
    return '<div class="mcd-item'+(on0?'':' off')+'" data-ix="'+ix+'" data-kit="0">'+
      '<input type="checkbox" class="mcd-item-chk" '+(on0?'checked':'')+'>'+
      '<span class="mcd-item-nm">'+esc(it.title)+(vt?'<small>'+esc(vt)+'</small>':'')+'</span>'+
      (isTroca?('<span class="mcd-piece-novo"'+(on0?'':' style="display:none"')+'>→ '+novoSelHtml(s.novos[0])+'</span>'):'')+
      '<span class="mcd-item-qty">×<input type="number" min="1" max="'+maxq+'" value="'+q+'"></span>'+
      '<span class="mcd-item-val">'+BRLk(num(it.price)*q)+'</span></div>';
  }).join('');
  bindItemEvents();
  updateSaveState();
}
function bindItemEvents(){
  el('mcd-items').querySelectorAll('.mcd-item').forEach(function(row){
    var ix=+row.getAttribute('data-ix');var kit=row.getAttribute('data-kit')==='1';var s=ensureSel(ix);
    if(kit){
      row.querySelectorAll('.mcd-kpiece').forEach(function(pr){
        var pi=+pr.getAttribute('data-pi');
        var chk=pr.querySelector('.mcd-piece-chk');
        chk.addEventListener('change',function(){s.pieces[pi]=chk.checked;pr.classList.toggle('off',!chk.checked);var nv=pr.querySelector('.mcd-piece-novo');if(nv)nv.style.display=chk.checked?'':'none';updateSaveState();});
        var nsel=pr.querySelector('.mcd-item-novo');if(nsel)nsel.addEventListener('change',function(){s.novos[pi]=nsel.value;});
      });
    }else{
      var chk=row.querySelector('.mcd-item-chk');var qin=row.querySelector('input[type=number]');var nsel=row.querySelector('.mcd-item-novo');
      chk.addEventListener('change',function(){s.pieces[0]=chk.checked;row.classList.toggle('off',!chk.checked);var nv=row.querySelector('.mcd-piece-novo');if(nv)nv.style.display=chk.checked?'':'none';updateSaveState();});
      if(qin)qin.addEventListener('input',function(){var it=edit.items[ix];var v=Math.min(num(qin.value)||1,num(it.quantity)||1);s.qtys[0]=v;row.querySelector('.mcd-item-val').textContent=BRLk(num(it.price)*v);});
      if(nsel)nsel.addEventListener('change',function(){s.novos[0]=nsel.value;});
    }
  });
}
function updateSaveState(){ el('mcd-modal-save').disabled=!anySelected(); }
function buildPayload(){
  var o=edit.order||{};
  var tipo=el('mcd-f-tipo-in').value;
  var selItems=[];
  Object.keys(edit.selected).forEach(function(ix){
    var it=edit.items[ix];var s=edit.selected[ix];if(!s)return;
    var info=itemInfo(it);var n=info.sizes.length;
    var unitPrice=num(it.price)/(info.kit?n:1);
    var unitCost=num(it.custo_unitario)/(info.kit?n:1);
    s.pieces.forEach(function(on,pi){
      if(!on)return;
      var qty=info.kit?1:(s.qtys[pi]||1);
      selItems.push({line_key:it.line_key,product_id:it.product_id,title:it.title,variant_title:it.variant_title,
        tamanho:info.sizes[pi]||it.tamanho||'',cor:it.cor,novo_tamanho:(tipo==='troca'?(s.novos[pi]||''):''),
        quantity:qty,price:unitPrice,line_revenue:unitPrice*qty,custo_unitario:unitCost,acao:tipo});
    });
  });
  var dataRet=el('mcd-f-data-ret').value||todayISO();
  var header={
    id:edit.id||uid(),order_id:o.id,order_number:o.order_number,data_pedido:o.created_at,
    data_devolucao:dataRet,data_retorno:dataRet,data_troca:(tipo==='troca'?el('mcd-f-data-troca').value:''),
    customer_id:o.customer_id,customer_name:o.customer_name,
    phone:o.phone,cidade:o.cidade,estado:o.estado,tipo:tipo,motivo:el('mcd-f-motivo-in').value,
    motivo_detalhe:el('mcd-f-motivo-det').value,obs:el('mcd-f-obs').value,
    custo_logistico:num(el('mcd-f-custolog').value),custo_reenvio:num(el('mcd-f-reenvio').value),
    troca_tamanho:'',
    status:el('mcd-f-status-in').value||'Em aberto',tracking_retorno:el('mcd-f-track-ret').value,
    tracking_troca:el('mcd-f-track-troca').value,canal:o.origem||'',cupom:o.cupom||'',origem:o.origem||''
  };
  return{header:header,itens:selItems};
}
/* atualiza estado local na hora (resposta instantânea) */
function applyLocalDev(header,items){
  var qtd=0,valor=0,custoProd=0;items.forEach(function(it){qtd+=num(it.quantity);valor+=num(it.line_revenue);custoProd+=num(it.custo_unitario)*num(it.quantity);});
  header.qtd_itens=qtd;header.valor_itens=Math.round(valor*100)/100;header.custo_produto=Math.round(custoProd*100)/100;
  if(!header.created_at)header.created_at=new Date().toISOString();
  header.updated_at=new Date().toISOString();
  var ix=-1;for(var i=0;i<devs.length;i++){if(devs[i].id===header.id){ix=i;break;}}
  if(ix>=0)devs[ix]=header;else devs.unshift(header);
  var newItens=items.map(function(it,k){return{id:header.id+'_'+k,devolucao_id:header.id,order_id:header.order_id,
    line_key:it.line_key,product_id:it.product_id,title:it.title,variant_title:it.variant_title,
    tamanho:it.tamanho,cor:it.cor,novo_tamanho:it.novo_tamanho||'',quantity:it.quantity,price:it.price,line_revenue:it.line_revenue,
    custo_unitario:it.custo_unitario,custo_linha:num(it.custo_unitario)*num(it.quantity),acao:it.acao};});
  itens=itens.filter(function(it){return it.devolucao_id!==header.id;}).concat(newItens);
  itensByDev[header.id]=newItens;
  cacheSet('mcd_devs_v1',{ts:Date.now(),rows:devs,itens:itens});
}
function saveDev(){
  if(Object.keys(edit.selected).length===0){toast('Selecione ao menos um item.');return;}
  var payload=buildPayload();
  applyLocalDev(payload.header,payload.itens);   // instantâneo
  el('mcd-modal-overlay').style.display='none';
  renderAll();
  toast('Devolução salva.');
  beginSave();
  mcCall('devolucao_save',{payload:JSON.stringify(payload)},function(err,d){
    endSave();
    if(err||(d&&d.error)){toast('Falha ao sincronizar — recarregando.');loadDevs();}
  });
}
function openEdit(id){
  var dv=devs.filter(function(d){return d.id===id;})[0];if(!dv)return;
  edit={id:dv.id,order:null,items:[],selected:{}};
  el('mcd-modal-title').textContent='Editar devolução';
  el('mcd-step-search').style.display='none';
  el('mcd-step-items').style.display='';
  el('mcd-modal-back').style.display='none';
  el('mcd-modal-del').style.display='';
  el('mcd-modal-overlay').style.display='flex';
  /* preenche header */
  el('mcd-f-data-ret').value=(dv.data_retorno||dv.data_devolucao||'').slice(0,10)||todayISO();
  el('mcd-f-data-troca').value=(dv.data_troca||'').slice(0,10);
  el('mcd-f-tipo-in').value=dv.tipo||'devolucao';refreshCS(el('mcd-f-tipo-in'));
  el('mcd-f-status-in').value=stNorm(dv.status);refreshCS(el('mcd-f-status-in'));
  el('mcd-f-motivo-det').value=dv.motivo_detalhe||'';
  el('mcd-f-custolog').value=dv.custo_logistico||'';
  el('mcd-f-reenvio').value=dv.custo_reenvio||'';
  el('mcd-f-obs').value=dv.obs||'';
  el('mcd-f-track-ret').value=dv.tracking_retorno||'';
  el('mcd-f-track-troca').value=dv.tracking_troca||'';
  var m=el('mcd-f-motivo-in');m.value=dv.motivo||'';refreshCS(m);
  toggleTrocaField();
  edit.order={id:dv.order_id,order_number:dv.order_number,customer_id:dv.customer_id,customer_name:dv.customer_name,
    phone:dv.phone,cidade:dv.cidade,estado:dv.estado,created_at:dv.data_pedido,origem:dv.origem,cupom:dv.cupom,faturamento:dv.valor_itens};
  el('mcd-order-head').innerHTML='<div><b>#MNC'+esc(dv.order_number)+'</b> — '+esc(dv.customer_name||'—')+'</div><span>'+esc(dv.estado||'')+' · '+fmtDate(dv.data_pedido)+'</span>';
  el('mcd-items').innerHTML='<p class="mc-empty" style="padding:10px">Carregando itens...</p>';
  var savedItens=itensByDev[dv.id]||[];
  mcCall('devolucao_order_items',{order_id:dv.order_id},function(err,d){
    edit.items=(d&&d.rows)||[];
    /* reconstrói seleção (peças por line_key) */
    edit.selected={};
    edit.items.forEach(function(it,ix){
      var info=itemInfo(it);
      var s={sizes:info.sizes,pieces:info.sizes.map(function(){return false;}),qtys:info.sizes.map(function(){return 1;}),novos:info.sizes.map(function(){return '';})};
      savedItens.filter(function(r){return String(r.line_key)===String(it.line_key);}).forEach(function(r){
        var pi=-1,k;
        for(k=0;k<info.sizes.length;k++){if(!s.pieces[k]&&String(info.sizes[k])===String(r.tamanho)){pi=k;break;}}
        if(pi<0)for(k=0;k<info.sizes.length;k++){if(!s.pieces[k]){pi=k;break;}}
        if(pi>=0){s.pieces[pi]=true;s.qtys[pi]=num(r.quantity)||1;s.novos[pi]=r.novo_tamanho||'';}
      });
      edit.selected[ix]=s;
    });
    renderItems();
  });
}
function delDev(){
  if(!edit.id)return;
  if(!confirm('Excluir esta devolução?'))return;
  var id=edit.id;
  devs=devs.filter(function(d){return d.id!==id;});          // instantâneo
  itens=itens.filter(function(it){return it.devolucao_id!==id;});
  delete itensByDev[id];
  cacheSet('mcd_devs_v1',{ts:Date.now(),rows:devs,itens:itens});
  el('mcd-modal-overlay').style.display='none';renderAll();toast('Devolução excluída.');
  beginSave();
  mcCall('devolucao_delete',{id:id},function(err,d){endSave();if(err||(d&&d.error))loadDevs();});
}

/* ============ MODAL MOTIVOS ============ */
function openMotivos(){renderMotivosList();el('mcd-mot-overlay').style.display='flex';}
function renderMotivosList(){
  el('mcd-mot-list').innerHTML=motivosSorted().map(function(m){
    return '<div class="mcg-cat-item" data-id="'+esc(m.id)+'">'+
      '<input class="mcg-cat-name-in" value="'+esc(m.nome)+'">'+
      '<button class="mcg-cat-item-del">✕</button></div>';
  }).join('')||'<p class="mc-empty">Nenhum motivo.</p>';
  el('mcd-mot-list').querySelectorAll('.mcg-cat-item').forEach(function(row){
    var id=row.getAttribute('data-id');
    var input=row.querySelector('.mcg-cat-name-in');
    input.addEventListener('change',function(){
      var m=motivos.filter(function(x){return x.id===id;})[0];if(!m)return;m.nome=input.value;
      beginSave();mcCall('dev_motivo_save',{id:id,nome:input.value,ordem:m.ordem,ativo:'1'},function(){endSave();fillMotivoSelects();});
    });
    row.querySelector('.mcg-cat-item-del').addEventListener('click',function(){
      motivos=motivos.filter(function(x){return x.id!==id;});renderMotivosList();fillMotivoSelects();
      beginSave();mcCall('dev_motivo_delete',{id:id},function(){endSave();});
    });
  });
}
function addMotivo(){
  var nm=el('mcd-mot-nm').value.trim();if(!nm)return;
  var id='M'+Date.now().toString(36);
  var m={id:id,nome:nm,tipo:'ambos',ordem:motivos.length+1,ativo:'1'};
  motivos.push(m);el('mcd-mot-nm').value='';renderMotivosList();fillMotivoSelects();
  beginSave();mcCall('dev_motivo_save',{id:id,nome:nm,ordem:m.ordem,ativo:'1'},function(){endSave();});
}

/* ============ range picker ============ */
function setupRange(){
  var wrap=el('mcd-rangepicker'),toggle=el('mcd-range-toggle'),lbl=el('mcd-range-label'),opts=el('mcd-range-opts');
  toggle.addEventListener('click',function(e){e.stopPropagation();wrap.classList.toggle('open');});
  document.addEventListener('click',function(){wrap.classList.remove('open');});
  opts.querySelectorAll('button[data-range]').forEach(function(btn){
    btn.addEventListener('click',function(e){
      e.stopPropagation();
      opts.querySelectorAll('button').forEach(function(b){b.classList.remove('is-active');});
      btn.classList.add('is-active');range=btn.dataset.range;
      var labels={'7d':'7 dias','30d':'30 dias','mes':'Mês','3m':'3 meses','ano':'Ano','max':'Máximo'};
      lbl.textContent=labels[range]||range;wrap.classList.remove('open');
      loadProdSales();renderAll();
    });
  });
}

/* ============ init ============ */
function init(){
  setupRange();
  el('mcd-btn-new').addEventListener('click',openNew);
  el('mcd-modal-close').addEventListener('click',closeModal);
  el('mcd-modal-cancel').addEventListener('click',closeModal);
  el('mcd-modal-save').addEventListener('click',saveDev);
  el('mcd-modal-del').addEventListener('click',delDev);
  el('mcd-modal-back').addEventListener('click',function(){
    el('mcd-step-items').style.display='none';el('mcd-step-search').style.display='';el('mcd-modal-back').style.display='none';el('mcd-modal-save').disabled=true;
  });
  el('mcd-mot-close').addEventListener('click',function(){el('mcd-mot-overlay').style.display='none';});
  el('mcd-mot-add').addEventListener('click',addMotivo);
  el('mcd-order-search').addEventListener('input',debounce(function(){searchOrders(el('mcd-order-search').value.trim());},350));
  el('mcd-order-search').addEventListener('focus',function(){if(el('mcd-order-search').value.trim().length<2)loadRecentOrders();});
  el('mcd-f-tipo-in').addEventListener('change',toggleTrocaField);
  el('mcd-seg-tipo').querySelectorAll('button').forEach(function(b){
    b.addEventListener('click',function(){
      el('mcd-f-tipo-in').value=b.getAttribute('data-v');
      toggleTrocaField();
    });
  });
  el('mcd-f-motivo-in').addEventListener('change',function(){
    if(this.value==='__newmot__'){this.value='';refreshCS(this);openMotivos();}
  });

  /* clicar fora fecha a janela */
  el('mcd-modal-overlay').addEventListener('click',function(e){if(e.target===el('mcd-modal-overlay'))closeModal();});
  el('mcd-mot-overlay').addEventListener('click',function(e){if(e.target===el('mcd-mot-overlay'))el('mcd-mot-overlay').style.display='none';});
  /* só bloqueia ao fechar a aba do navegador enquanto salva */
  window.addEventListener('beforeunload',function(e){if(pendingSaves>0){e.preventDefault();e.returnValue='';}});

  /* filtros */
  el('mcd-perpage').addEventListener('change',function(){listPerPage=+this.value||10;listPage=1;renderList(applyFilters());});
  el('mcd-search').addEventListener('input',debounce(function(){filters.q=el('mcd-search').value.trim();listPage=1;renderAll();},250));
  el('mcd-f-tipo').addEventListener('change',function(){filters.tipo=el('mcd-f-tipo').value;renderAll();});
  el('mcd-f-motivo').addEventListener('change',function(){filters.motivo=el('mcd-f-motivo').value;renderAll();});
  el('mcd-f-estado').addEventListener('change',function(){filters.estado=el('mcd-f-estado').value;renderAll();});
  el('mcd-f-status').addEventListener('change',function(){filters.status=el('mcd-f-status').value;renderAll();});
  el('mcd-filter-clear').addEventListener('click',function(){
    filters={q:'',tipo:'',motivo:'',estado:'',status:''};
    el('mcd-search').value='';['mcd-f-tipo','mcd-f-motivo','mcd-f-estado','mcd-f-status'].forEach(function(id){var s=el(id);s.value='';refreshCS(s);});
    renderAll();
  });
  el('mcd-rank-sort').addEventListener('change',function(){rankSort=el('mcd-rank-sort').value;renderAll();});
  el('mcd-cross-dim').addEventListener('change',function(){crossDim=el('mcd-cross-dim').value;renderAll();});
  el('mcd-tl-gran').addEventListener('change',function(){tlGran=el('mcd-tl-gran').value;renderAll();});

  var kpiIcons={'mcd-ic-taxa':'chart','mcd-ic-cart':'cart','mcd-ic-swap':'swap','mcd-ic-prej':'alert','mcd-ic-tag':'tag','mcd-ic-pct':'percent','mcd-ic-coins':'coins','mcd-ic-truck':'truck','mcd-ic-tempo':'clock','mcd-ic-eco':'bulb'};
  Object.keys(kpiIcons).forEach(function(id){var e=el(id);if(e)e.innerHTML=icSvg(kpiIcons[id]);});

  // Auto-refresh silencioso: pega devoluções cadastradas por outros usuários sem recarregar a página
  setInterval(function(){
    if(document.hidden)return;
    mcCall('devolucoes_list',{},function(err,d){
      if(err||!d||!d.rows)return;
      devs=d.rows;itens=d.itens||[];rebuildItensIndex();
      cacheSet('mcd_devs_v1',{ts:Date.now(),rows:devs,itens:itens});renderAll();
    });
  },60000);
  wireDiagDrawer();
  buildAllCS();
  loadMotivos();
  loadOrders();
  loadProdSales();
  loadDevs();
  prefetchRecent();
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();